// Story 8.3 (ADO-2012), Task 11.1: the Conflict Message (Figma "Conflict Message", with the
// component properties `Message` and `Show action`). A new primitive, not the warning
// Banner: it is smaller (16px icon, 8px gap, 8px 10px padding, 6px radius) and its text is
// text primary, with an optional action under the message.
//
// It tells the person their change to a cart line was refused because the line changed
// since they saw it, and never says who changed it (story D-12).
//
// a11y: role="alert", as the warning Banner and the cart row's error use, since it reports
// the outcome of the person's own action. `announce={false}` drops it where another element
// already announces the outcome (story 8.3 card 09: the banner, not each marked line). The icon is decorative; the message carries the
// meaning, so colour is never the only signal. The action changes the cart (it does not
// navigate), so it is a <button> drawn as a link, with the 44px hit area from an invisible
// layer (ConflictMessage.module.css).

import { Icon } from '../Icon/Icon';
import styles from './ConflictMessage.module.css';

export interface ConflictMessageAction {
  /** The designer's label, word for word (for example "Change to 4"). */
  readonly label: string;
  readonly onClick: () => void;
}

export interface ConflictMessageProps {
  /** The designer's message, word for word (story DV-3). */
  readonly message: string;
  /** Figma `Show action`: omitted, the message stands alone. */
  readonly action?: ConflictMessageAction;
  readonly className?: string;
  /** False: no `role="alert"`, for a message another element already announces. */
  readonly announce?: boolean;
}

export function ConflictMessage({
  message,
  action,
  className,
  announce = true,
}: ConflictMessageProps) {
  return (
    <div
      className={className === undefined ? styles.message : `${styles.message} ${className}`}
      role={announce ? 'alert' : undefined}
      data-conflict-message=""
    >
      <Icon name="warning" size={16} className={styles.icon} />
      <div className={styles.body}>
        <span className={styles.text}>{message}</span>
        {action === undefined ? null : (
          <button type="button" className={styles.action} onClick={action.onClick}>
            {action.label}
          </button>
        )}
      </div>
    </div>
  );
}
